import React, { useEffect } from 'react';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import PatientUpdateStackParamsList from 'src/routes/stacks/PatientUpdateStackNavigator/ParamsList';
import { Screens } from 'src/routes/stacks/screens';
import PatientListRoot from '../PatientList';
import { Patient } from 'src/interfaces';
import { ChevronLeft } from 'react-native-feather';
import { HoverButton } from 'src/components';
import { useAppTheme } from 'src/providers/AppThemeProvider';
import styled from 'styled-components/native';
import { Margin } from 'src/constants';

const PatientSelector: React.FC<
  NativeStackScreenProps<PatientUpdateStackParamsList, Screens.REQUESTS_PATIENT_SELECTOR>
> = ({ route, navigation }) => {
  const { colors } = useAppTheme();
  useEffect(() => {
    navigation.setOptions({
      headerLeft: () => <BackButton onPress={navigation.pop} />
    });
  }, [colors.text, navigation]);
  if (route?.params?.dismiss) {
    // Navigate to requests home
  }

  const petNavOverride = (id: Patient['patientId']) => {
    navigation.navigate(Screens.PATIENT_PROFILE_UPDATE, { id });
  };

  return <PatientListRoot petNavOverride={petNavOverride} />;
};

const BackButton = styled(HoverButton).attrs({
  icon: ChevronLeft,
  mode: 'contained'
})`
  padding: ${Margin.Small}px;
  border-radius: ${Margin.ExtraLarge}px;
  flex-shrink: 0;
  margin-left: ${Margin.Large}px;
  margin-vertical: ${Margin.Large}px;
`;

export default PatientSelector;
